import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export const CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO = '@bloqueioPoltronasTemporarioActions/CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO';
export const LIBERAR_BLOQUEIO_POLTRONAS_TEMPORARIO = '@bloqueioPoltronasTemporarioActions/LIBERAR_BLOQUEIO_POLTRONAS_TEMPORARIO';


export function criarBloqueioPoltronasTemporario(dados) {
    let url = `${URL}/bloqueio-poltrona-temporario`;
    return dispatch => axios.post(url, dados, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO,
            payload: response
        })
    );
}

export function liberarBloqueioPoltronasTemporario(ids) {
    const url = `${URL}/bloqueio-poltrona-temporario/liberar`;
    return dispatch => axios.post(url, ids, SLOW_REQUEST_CONFIG).then(
        dispatch({
            type: LIBERAR_BLOQUEIO_POLTRONAS_TEMPORARIO,
            payload: ids
        })
    );
}

